import React from "react";
import "../styles/ClubPage.css";

const SponsorsList = ({ sponsors }) => {
    return (
        <>
            <h2>Our Sponsors</h2>

            {sponsors.length > 0 ? (
                <div className="sponsor-logos">
                    {sponsors.map((sponsor, index) => (
                        <div key={index} className="sponsor-logo">{sponsor}</div>
                    ))}
                </div>
            ) : (
                <p className="no-sponsors"> Our beloved main sponsor's logo will be here soon! </p>
            )}
        </>
    );
};

export default SponsorsList;
